import { useState } from "react";
import { addProductsForm } from "../../lib/actions";
import DropDownFilterPaginations from "../../components/GDropDownList/DropDownFilterPaginations";
import { ThreeDot } from "react-loading-indicators";
import { useTranslation } from "react-i18next";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FiUploadCloud } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

    export default function AddProductUi({ categoriesData, storesData, searchCategories, searchStores }) {

        const nav = useNavigate();
        const [categoryId, setCategoryId] = useState(null);
        const [storeId, setStoreId] = useState(null);
        const [image, setImage] = useState(null);
        const [loading, setLoading] = useState(false);
        const [check, setCheck] = useState(false);
        const { i18n } = useTranslation();
        const t = i18n.t.bind(i18n);
        const currentLang = i18n.language;

        const onchangeCategory = (e) => setCategoryId(e);
        const onchangeStore = (e) => setStoreId(e);

        const handleChangeCheck = () => {
            setCheck(!check);
        };

        const handleSubmit = async (e) => {
            setLoading(true);
            e.preventDefault();
            const formData = new FormData(e.target);
            const result = await addProductsForm(formData, navigate);
            setLoading(false);
        };

        const navigate = (route) => {
            nav(route);
        };

        const handleImageChange = (e) => {
            if (e.target.files && e.target.files[0]) {
                const file = e.target.files[0];
                setImage(URL.createObjectURL(file));
            }
        };

        const handleDeleteImage = () => setImage(null);

        if ((categoriesData).length < 1 || (storesData).length < 1) {
            return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#2F7A74" size="large" text="" textColor="" /></div>
        };

        return (

            <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">
                    <div className="mb-4">
                        <label className="block text-white mb-2">{currentLang === "en" ? "title in arabic" : "العنوان باللغة العربية "}</label>
                        <input type="text" name="title[ar]" className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg" required placeholder={currentLang === "en" ? "enter title in arabic" : "أدخل العنوان باللغة العربية " } />
                    </div>

                    <div className="mb-4">
                        <label className="block text-white mb-2">{currentLang === "en" ? "title in english" : "العنوان باللغة الانجيليزية "}</label>
                        <input type="text" name="title[en]" className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg" required placeholder={currentLang === "en" ? "enter title in english" : " أدخل العنوان باللغة الانجليزية " } />
                    </div>

                    <div className="mb-4">
                        <label className="block text-white mb-2">{currentLang === "en" ? "description in arabic" : "الوصف باللغة العربية "}</label>
                        <input type="text" name="description[ar]" className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg" placeholder={currentLang === "en" ? "enter description in arabic" : "أدخل الوصف باللغة العربية " } />
                    </div>

                    <div className="mb-4">
                        <label className="block text-white mb-2">{currentLang === "en" ? "description in english" : "الوصف باللغة الانجليزية "}</label>
                        <input type="text" name="description[en]" className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg" placeholder={currentLang === "en" ? "enter description in english" : "أدخل الوصف باللغة الانجليزية " } />
                    </div>

                    <div className="mb-4">
                        <label className="block text-white mb-2">{currentLang === "en" ? "category" : "الفئة"}</label>
                        <DropDownFilterPaginations search={searchCategories} options={categoriesData} value={categoryId} onchange={onchangeCategory} defaultText={currentLang === "en" ? "Select the category" : "أختر الفئة (اختياري) "} paramkey="sub_category_id" />
                    </div>

                    <div className="mb-4">
                        <label className="block text-white mb-2">{currentLang === "en" ? "store" : "المتجر"}</label>
                        <DropDownFilterPaginations search={searchStores} options={storesData} value={storeId} onchange={onchangeStore} defaultText={currentLang === "en" ? "Select the store" : "أختر المتجر (اختياري) "} paramkey="store_id" />
                    </div>

                    <div className="mb-4">
                        <label className="block text-white mb-2">price</label>
                        <input type="number" step="any" name="price" className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg" placeholder="0.00" />
                    </div>

                    <div className="flex items-center gap-4 ms-3">
                        <div
                            onClick={handleChangeCheck}
                            className={`relative w-14 h-6 rounded-full cursor-pointer transition
                            ${check ? (currentLang === 'ar' ? 'bg-secondary' : 'bg-secondary') : (currentLang === 'ar' ? 'bg-gray-400' : 'bg-gray-400')}`}
                        >
                            <span
                            className={`w-5 h-4 mt-1 bg-white rounded-full shadow-md block
                                transform transition
                                ${check ? (currentLang === 'ar' ? '-translate-x-1' : 'translate-x-7') : (currentLang === 'ar' ? '-translate-x-7' : 'translate-x-1')}`}
                            />
                        </div>
                        <label className="text-white">
                        {check
                            ? currentLang === "en"
                            ? "Is Offer"
                            : "عرض"
                            : currentLang === "en"
                            ? "Not Offer"
                            : "لا يوجد عرض"
                        }
                        </label>
                    </div>

                    { check && <>
                        <div className="mb-4">
                            <label className="block text-white mb-2">final price</label>
                            <input type="number" step="any" name="final_price" className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg" placeholder="0.00" />
                        </div>

                        <div className="mb-4">
                            <label className="block text-white mb-2">start time</label>
                            <input type="date" name="start_time" className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg" />
                        </div>

                        <div className="mb-4">
                            <label className="block text-white mb-2">end time</label>
                            <input type="date" name="end_time" className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg" />
                        </div>
                    </>}
                    </div>

                <div className="my-6">
                        <label className="block text-white mb-6">{currentLang === "en" ? "main photo" : "الصورة الرئيسية"}</label>
                        <div className="flex justify-center items-center">
                            <div className="bg-thirdly sm:w-[50%] w-[100%] p-6 rounded-2xl border-2 border-dashed border-gray-200">
                                <div className="relative group">
                                    <div className={`flex flex-col items-center justify-center h-48 ${!image ? 'bg-furthly' : 'bg-transparent'} rounded-xl transition-all`}>
                                        {!image ? (
                                            <>
                                                <FiUploadCloud className="w-12 h-12 text-white mb-3 group-hover:text-secondary transition-colors" />
                                                <span className="text-sm text-white group-hover:text-secondary transition-colors">{currentLang === "en" ? "click to upload a photo" : " انقر لرفع الصورة"}</span>
                                            </>
                                        ) : (
                                        <div className="relative w-full h-full">
                                            <img src={image} alt="الصورة الملتقطة" className="w-full h-full object-contain rounded-xl" />
                                            <button type="button" className="absolute top-2 left-2 z-50 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors shadow-lg" onClick={handleDeleteImage}>
                                                <MdOutlineDeleteOutline className="w-5 h-5" />
                                            </button>
                                        </div>
                                        )}
                                    </div>
                                <input type="file" name="main_photo" accept="image/*" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleImageChange} required />
                                </div>
                            </div>
                        </div>
                </div>
                <div className="flex justify-center w-full mt-5">
                    <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                    <svg className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path></svg>
                    ) : (
                    t("button.save")
                    )}
                    </button>
                </div>
            </form>
        );
    }